<h1 mat-dialog-title>{{"STATUS.STATUS"|translate}}</h1>
<div mat-dialog-content>
  <p>{{"STATUS.SELECTSTATUS"|translate}}</p>
  <ldw-status-select [initialValue]="data"
                     (statusChanged)="statusHasChanged($event)"
                     [emptyDisplayValue]="'STATUS.NONE'| translate"></ldw-status-select>
</div>
<div mat-dialog-actions>
  <button mat-button (click)='okClick()' cdkFocusInitial>{{"DIALOGS.OK"|translate}}</button>
  <button mat-button (click)="cancelClick()">{{"DIALOGS.CANCEL"|translate}}</button>
</div>
